import React, { useState, useEffect } from 'react';
import PipelineView from '../components/PipelineView';

interface PieceData {
  slug: string;
  pipelineStatus?: string;
  runningStage?: string;
  completedStages?: string[];
  failedStage?: string;
  stages: Record<string, any>;
}

interface ActivityViewProps {
  brand: string;
  pieces: PieceData[];
}

function humanTitle(slug: string): string {
  return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

export default function ActivityView({ brand, pieces }: ActivityViewProps) {
  const [logs, setLogs] = useState<any[]>([]);

  const running = pieces.filter((p) => p.pipelineStatus === 'running');

  useEffect(() => {
    fetch(`/api/${brand}/logs?limit=20`)
      .then((r) => r.json())
      .then((data) => { if (Array.isArray(data)) setLogs(data); })
      .catch(() => {});
  }, [brand]);

  return (
    <div className="view-page">
      <h2 className="view-page__title">Activity</h2>

      {running.length > 0 && (
        <div style={{ marginBottom: 32 }}>
          <h3 className="view-section-title">Running Now</h3>
          {running.map((p) => (
            <div key={p.slug} style={{ marginBottom: 20, padding: 20, background: 'var(--bg)', border: '1px solid var(--accent)', borderRadius: 0 }}>
              <PipelineView
                slug={p.slug}
                stages={p.stages || {}}
                runningStage={p.runningStage}
                completedStages={p.completedStages}
                failedStage={p.failedStage}
              />
            </div>
          ))}
        </div>
      )}

      {running.length === 0 && (
        <div style={{ color: 'var(--text-tertiary)', padding: '20px 0' }}>
          No pipelines running. Trigger a pipeline from the Library to see live progress here.
        </div>
      )}

      {logs.length > 0 && (
        <div>
          <h3 className="view-section-title">Recent Logs</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {logs.map((log, i) => (
              <div key={i} style={{ display: 'flex', gap: 12, fontSize: 12, padding: '6px 0', borderBottom: '1px solid var(--border-light)', color: 'var(--text-secondary)' }}>
                <span style={{ color: 'var(--text-tertiary)', fontFamily: 'var(--mono)', minWidth: 70 }}>{log.timestamp ? new Date(log.timestamp).toLocaleTimeString() : ''}</span>
                <span style={{ fontWeight: 500, minWidth: 80 }}>{log.slug || ''}</span>
                <span style={{ flex: 1 }}>{log.message || log.event || JSON.stringify(log).slice(0, 100)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
